import { Box, Flex, Heading, Container, AspectRatio, Skeleton, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import Image from 'next/image';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EventTicketPrompt } from '@/components/ui/shared/event-ticket/EventTicketPrompt/EventTicketPrompt';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';
import { ThinEvent } from '@/resources/ThinEvent';

interface INoTicketProps {
  event: ThinEvent;
}

export const NoTicket: FC<INoTicketProps> = ({ event }) => {
  const { t } = useTranslation();
  const { data: session } = useQuery(sessionQueryOptions());
  const user = session?.user;

  return (
    <Container>
      <Flex alignItems={{ base: 'flex-start', lg: 'center' }} pt={24}>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          gap={{ base: 7, lg: 12 }}
          w="full"
          flex={1}
          h={{ base: 'auto', lg: '430px' }}
          justifyContent="center"
          alignItems="center"
        >
          <AspectRatio
            w="full"
            maxW={{ base: 'auto', lg: '626px' }}
            h={{ base: '160px', sm: '330px', lg: '430px' }}
            ratio={4 / 3}
          >
            {event?.mediumHeaderImageUrl ? (
              <Image
                sizes="(max-width: 480px) 160px, (max-width: 1200px) 330px, 430px"
                priority
                fill
                src={event?.mediumHeaderImageUrl}
                alt={event?.name}
              />
            ) : (
              <Box />
            )}
          </AspectRatio>
          <Flex flexDir="column" flex={1} justifyContent="space-around" h="full">
            <Heading mb={{ base: 7, lg: 0 }} fontSize={{ base: '2xl', md: '3xl' }}>
              {event?.missingTicketTitle ? event.missingTicketTitle : t('noTicket.title')}
            </Heading>
            <Flex flexDir="column">
              <Text mb={4}>
                Currently logged in with:{' '}
                <Text as="span" fontWeight="bold">
                  {user.email}
                </Text>
              </Text>
              <EventTicketPrompt eventId={event?.id} />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};
